import React from 'react';
import Icon from './icon';

function LinkedIn(props) {
  return (
    <Icon {...props}>
      <path id="LinkedIn_6_" className="st0" d="M300,184v110.9h-64.3V191.4c0-26-9.3-43.7-32.6-43.7c-17.8,0-28.3,12-33,23.5
		c-1.7,4.1-2.1,9.9-2.1,15.7v108h-64.3c0,0,0.9-175.2,0-193.4H168v27.4c-0.1,0.2-0.3,0.4-0.4,0.6h0.4v-0.6c8.5-13.2,23.8-32,58-32
		C268.3,97,300,124.6,300,184z M36.4,8.3c-22,0-36.4,14.4-36.4,33.4c0,18.6,14,33.4,35.5,33.4H36c22.4,0,36.4-14.9,36.4-33.4
		C72,22.7,58.4,8.3,36.4,8.3z M3.9,294.9h64.3V101.5H3.9V294.9z"/>
    </Icon>
  )
}

export default LinkedIn;



// WEBPACK FOOTER //
// ./src/icons/components/in.js